import styled from 'styled-components'

export const StyledBlockTitleBar = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  div.icon {
    padding: 0.1rem;
    margin: 0 0.1rem;
    cursor: pointer;
  }

  .remove {
    flex: 0 17px;
  }
`

export const BlockTitle = styled.label`
  color: #4b4b4b;
  font-size: 0.95rem;
  font-weight: bold;
  display: block;
  margin-right: auto;
  margin-bottom: 0;
`

export const Label = styled.label`
  color: #4b4b4b;
  font-size: 0.875rem;
  font-weight: bold;
  display: block;
  margin-right: auto;
  margin-bottom: 0;
`

export const BlockBorder = styled.div`
  border-radius: 5px;
  border: 1px solid #cccccc;
  padding: 10px;
  margin: 10px 0;
`
